import React from "react";
import type {
  GeneralBynderAsset,
  HeroBlockWithLiveText as HeroBlockWithLiveTextType,
  ReducedImage
} from "types/cms";
import { colours } from "@shared/ui.design-system";
import type { CMSPageProps } from "packages/acquisition/components/chakra-components/LandingPage/LandingPage.utils";
import { MobileImage } from "./components/MobileImage";
import { DesktopImage } from "./components/DesktopImage";
import { MainContent } from "./components/MainContent";
import { MobileContent } from "./components/MobileContent";
import { cleanTitle } from "components/Contentful/RichTextRenderer/RichTextRenderer.utils";
import {
  outerContainer,
  innerContainer,
  innerContainerTop,
  innerContainerBottom,
  innerContainerCenter
} from "./HeroBlockWithLiveText.css";

import { innerContainerPosition } from "./components/common.css";

type Props = CMSPageProps & HeroBlockWithLiveTextType;

const alignmentMap = {
  Top: innerContainerTop,
  Center: innerContainerCenter,
  Bottom: innerContainerBottom
};

const convertUTCDateToLocalDate = (date: Date) => {
  const newDate = new Date(date.getTime());

  return newDate;
};

export const HeroBlockWithLiveText: React.FC<Props> = ({
  trackingModule,
  title,
  showTitleOnImageInMobileView,
  subHeading,
  showSubHeadingOnImageInMobileView,
  bodyCopy,
  bodyCopyBackgroundColor,
  bannerCta,
  desktopContentAlignment,
  mobileContentAlignment,
  imageDesktopRef,
  imageMobileRef,
  fontColor = "Black",
  fontColorDesktop = "Black",
  countdown,
  showBodyCopy
}) => {
  const todaysDate = new Date();
  const endDate = convertUTCDateToLocalDate(
    new Date(countdown?.countdownEndDate ?? new Date().toISOString())
  );

  if (countdown && todaysDate > endDate) {
    return null;
  }

  const { modulePosition } = trackingModule;
  const mobileBackgroundColor = countdown
    ? colours.accent.soft
    : (bodyCopyBackgroundColor ?? colours.secondary.light);

  const innerContainerClass = `${innerContainer} ${
    showTitleOnImageInMobileView && alignmentMap[mobileContentAlignment]
  } ${innerContainerPosition[desktopContentAlignment ?? "Left"]}`;

  const src =
    (imageMobileRef as ReducedImage)?.src ??
    (imageMobileRef as GeneralBynderAsset)?.bynderData?.[0]?.thumbnails[
      "OTF BETA"
    ];
  const desktopSrc =
    (imageDesktopRef as ReducedImage)?.src ??
    (imageDesktopRef as GeneralBynderAsset)?.bynderData?.[0]?.thumbnails[
      "OTF BETA"
    ];
  return (
    <div
      className={outerContainer}
      id={cleanTitle(title)}
      style={{
        backgroundColor: mobileBackgroundColor
      }}
    >
      <div className={innerContainerClass}>
        <MobileImage
          imageSrc={src}
          title={imageMobileRef?.description ?? title}
          modulePosition={modulePosition}
        />
        <DesktopImage
          imageSrc={desktopSrc}
          title={imageDesktopRef?.description ?? title}
          modulePosition={modulePosition}
        />
        <MainContent
          bannerCta={bannerCta}
          bodyCopy={bodyCopy}
          countdown={countdown}
          desktopContentAlignment={desktopContentAlignment}
          fontColor={fontColor}
          fontColorDesktop={fontColorDesktop}
          modulePosition={modulePosition}
          showSubHeadingOnImageInMobileView={showSubHeadingOnImageInMobileView}
          showTitleOnImageInMobileView={showTitleOnImageInMobileView}
          subHeading={subHeading}
          title={title}
          trackingModule={trackingModule}
          showBodyCopy={showBodyCopy}
        />
      </div>
      <MobileContent
        bannerCta={bannerCta}
        bodyCopy={bodyCopy}
        countdown={countdown}
        desktopContentAlignment={desktopContentAlignment}
        fontColor={fontColor}
        modulePosition={modulePosition}
        showSubHeadingOnImageInMobileView={showSubHeadingOnImageInMobileView}
        subHeading={subHeading}
        trackingModule={trackingModule}
        showBodyCopy={showBodyCopy}
      />
    </div>
  );
};
